"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetTeamMembersByTeamId = void 0;

var _reactRedux = require("react-redux");

var _react = require("react");

var _utils = require("@alycecom/utils");

var _members = require("../store/members/members.selectors");

var _members2 = require("../store/members/members.actions");

var useGetTeamMembersByTeamId = function useGetTeamMembersByTeamId(teamId) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var status = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    return teamId ? (0, _members.makeGetMembersStatusByTeamId)(teamId) : function () {
      return _utils.StateStatus.Idle;
    };
  }, [teamId]));
  var isIdle = status === _utils.StateStatus.Idle;
  var isPending = status === _utils.StateStatus.Pending;
  var isFulfilled = status === _utils.StateStatus.Fulfilled;
  var selectors = (0, _react.useMemo)(function () {
    return (0, _members.makeGetMembersSelectorsByTeamId)(teamId);
  }, [teamId]);
  (0, _react.useEffect)(function () {
    if (teamId && isIdle) {
      dispatch((0, _members2.fetchMembersByTeamId)(teamId));
    }
  }, [dispatch, teamId, isIdle]);

  var useGetById = function useGetById(id) {
    return (0, _reactRedux.useSelector)(selectors.getById(id));
  };

  var useGetIds = function useGetIds() {
    return (0, _reactRedux.useSelector)(selectors.getIds);
  };

  var useGetAll = function useGetAll() {
    return (0, _reactRedux.useSelector)(selectors.getAll);
  };

  var useGetEntities = function useGetEntities() {
    return (0, _reactRedux.useSelector)(selectors.getEntities);
  };

  var useGetTotal = function useGetTotal() {
    return (0, _reactRedux.useSelector)(selectors.getTotal);
  };

  return {
    isIdle,
    isPending,
    isFulfilled,
    useGetById,
    useGetIds,
    useGetAll,
    useGetEntities,
    useGetTotal
  };
};

exports.useGetTeamMembersByTeamId = useGetTeamMembersByTeamId;